<template>
    <div id='popupbackground' :class="getPopupClass()" v-if='display' >
        <div id='popup' @keyup.enter="clickBtnForm()">
            <button v-if="showCloseBtn()"  @click="closeForm()" id='closeFormBtn'>X</button>
            
            <h1 class="form_title" v-if="type != 'mini'">{{title_txt}}</h1>

            <!--  Ligne d'Erreur : TODO faire une fonction avec des parametres pour toutes les erreurs / plus evolutifs et discret -->
            <div class="form_row form_error" v-if="errorTxt != ''">
                <span>{{errorTxt}}</span>
            </div>

            <!-- Bouton de validation : 1 bouton-->
            <button @click="clickBtnForm()" class="form_button">
                <span >{{btn_txt}}</span>
            </button>

        </div>
    </div>
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums';

    export default {
        name: "Popup",
        mixins: [FctUtils],
        components: {

        }, 
        props:{
            id:'',
        },
        data: function () {
            return {
                display:false,
                validation:false,
                type:'none',  // défini l'apparence de la fenetre (alert, mini)
                mode:'none',  // défini le contenu des textes
                title_txt:'',
                btn_txt:'',
                errorTxt:"",
                // password: '',
            }
        },
        created() {
            this.SUPERADMIN = RoleEnum.SUPERADMIN;
            this.ADMIN      = RoleEnum.ADMIN;
            this.LINGUIST   = RoleEnum.LINGUIST;
        },
        mounted() {
            this.emitter.on('showPopup', newPopupInfos => {
                this.showPopup(newPopupInfos)
            });
        },
        computed:{
            getStatus:function() {
                return this.$store.getters.status;
            },
            
        },
        methods:{
            isRole(roleTest) {
                return this.$store.state.currentUser.role == roleTest;
            },
            isRoleAbove(roleTest) {
                if (this.isRole(RoleEnum.SUPERADMIN.value)) {
                    return true;
                }
                else if (this.isRole(RoleEnum.ADMIN.value) && roleTest != RoleEnum.SUPERADMIN.value) {
                    return true;
                }

                return false;
            },
            showPopup(newPopupInfos){
                if (this.id == 'popup' && newPopupInfos.mode.indexOf('error') != -1) {
                    this.display = true;    
                }
                this.mode=newPopupInfos.mode;

                switch(this.mode) {
                    case 'error_maj' : {
                        this.type = 'mini';
                        this.title_txt='Message';
                        this.btn_txt='Ok';
                        this.errorTxt="Une mise à jour empêche momentanément l’envoi de vos modifications, veuillez réessayer dans quelques instants.";
                    } break;
                    case 'error_refresh' : {
                        this.type = 'alert';
                        this.title_txt='ANOMALIE';
                        this.btn_txt='Ok';
                        this.errorTxt="L’envoi de vos modifications a rencontré une erreur.";
                    } break;
					case 'error_unavailable' : {
						this.type      = 'alert';
						this.title_txt = 'Indisponible';
						this.btn_txt   = 'Ok';
						this.errorTxt  = "Cette fonctionnalité n’est pas encore disponible.";
					} break;
					// Erreur avec texte passé en paramètre.
					//
					case 'error_custom' : {
						this.type    = 'alert';
						this.btn_txt = 'Ok';

						if (FctUtils.methods.noEmpty(newPopupInfos.title)) {
							this.title_txt = newPopupInfos.title;
						}
						else {
							this.title_txt = 'Erreur';
						}

						if (FctUtils.methods.noEmpty(newPopupInfos.text)) {
							this.errorTxt = newPopupInfos.text;
						}
						else {
							this.errorTxt = 'Erreur';
						}
					} break;
                }
            },
            showCloseBtn() {
                return true;
            },
            clickBtnForm() {
                this.closeForm();
            },
            closeForm(){
                this.display = false;
                this.type='none';
                this.mode='none';
                this.errorTxt="";
            },
            getPopupClass() {
                var result = ""
                result += " " + this.type ;
                return result;
            },
        }
    }
</script>


<!-- 
    Attention, le CSS ici n'est pas scoped, car j'utilise les form dans une autre page
    -> User.vue
-->
<style >

#popupbackground {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index: 10;

    background-color: #88888870;

    /* Attention IE */
    display: flex;
    align-items: center;
    justify-content: center;
}

#popupbackground.mini {
    align-items: baseline;
    justify-content: end;
}

#closeFormBtn {
    background: none;
    border: none;
    position: absolute;
    color: #cc0b00;
    font-weight: bold;
    font-family: "Titillium Web";
    font-size: 13pt;
    right: 6px;
    top: 3px;
}

.mini #closeFormBtn {
    right: 5px;
    top: 5px;
}

#popup {
    position: relative;
    background-color: #ffffff;
    width: 540px;
    max-width: 100%;
    border-radius: 16px;
    padding: 32px;
}

.mini #popup {
    top :102px;
    right: 80px;
    width: 250px;
    border-radius: 16px;
    padding: 12px;
}

.form_title {
    text-align: center;
    font-weight: bold;
}

.mini .form_title {
    font-size: 2em;
}

.form_row {
    display: flex;
    margin: 16px 0px;
    gap: 16px;
    flex-wrap: wrap;
}

.mini .form_row {
    margin: 4px 0px;
    gap: 16px;
}

.form_button {
    background: #2196F3;
    color: white;
    border-radius: 8px;
    font-weight: 800;
    font-size: 15px;
    border: none;
    width: 100%;
    padding: 16px;
    transition: .4s background-color;
}

.mini .form_button {
    float: right;
    width: 15%;
    padding: 4px;
}

.form_button:hover:not(.form_button_disabled) {
    background: #63ace7;
}

.form_button:active:not(.form_button_disabled) {
  transform: translateY(2px);
}

.form_button_disabled {
    background: #cecece;
    color: #ececec;
    cursor:not-allowed;
}

.form_button.half_btn {
    width:49%;
}

.form_error{
    color:#cc0b00;
    font-weight: bold;
    justify-content: center;
}

.mini .form_error{
    font-weight: normal;
    color:#424242;
}

</style>
